import React, { useRef } from 'react'
import { Card } from 'reactstrap';
import { useSelector } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import MailBody1 from './MailBody1';
import UserMail from './UserMail';
import { RootState } from '../../../../../../redux-toolkit/store';

export default function EmailRead() {
    const { interviewEmail } = useSelector((state: RootState) => state.email);
    const contentRef = useRef<HTMLDivElement>(null);
    const handlePrint = useReactToPrint({
      contentRef,
    });

    return (
      <Card className={`email-body email-read ${interviewEmail ? "show" : "hide"}`}>
        <MailBody1 />
        <div className="mail-body-wrapper" ref={contentRef}>
          <UserMail handlePrint={handlePrint} />
        </div>
      </Card>
    );
}
